import { type ListBoxItem } from '@direct-frontend/components';

export const MAX_AVAILABLE_PRICE = Number.MAX_SAFE_INTEGER;
export const MIN_AVAILABLE_PRICE = 1;

export const DEFAULT_VAT: number = 22; // %

export const VAT_ITEMS = [
    { value: '-1', content: 'Не облагается' },
    { value: '0', content: '0 %' },
    { value: '5', content: '5 %' },
    { value: '7', content: '7 %' },
    { value: '10', content: '10 %' },
    { value: DEFAULT_VAT.toString(), content: `${DEFAULT_VAT} %` },
] as const satisfies ListBoxItem[];

export const TAX_SYSTEM_ITEMS = [
    { value: '0', content: 'Общая система налогообложения' },
    { value: '1', content: 'Упрощенная система налогообложения (Доход)' },
    { value: '2', content: 'Упрощенная система налогообложения (Доход минус Расход)' },
    { value: '3', content: 'Единый налог на вмененный доход' },
    { value: '4', content: 'Единый сельскохозяйственный налог' },
    { value: '5', content: 'Патентная система налогообложения' },
] as const satisfies ListBoxItem[];
